import(/* webpackMode: "eager" */ "/vercel/path0/app/(public)/jobs/[id]/page.tsx");
